export default {
  HasPermission (permission) {
    const metas = permission.split(',')
    var hasPermission = false
    metas.forEach(p => {
      if (Permissions.indexOf(p) !== -1) {
        hasPermission = true
      }
    })
    return hasPermission
  },
  ConvertToRealNumber (num) {
    return Math.round(100 * parseFloat(num))
  },
  DisplayAsCurrency (num) {
    return '$' + this.ConvertRealToMonetary(num)
  },
  ConvertRealToMonetary (num) {
    return (num / 100).toFixed(2)
  },
  ConvertRealToMonetaryZero (num) {
    return (num / 100).toFixed(0)
  },
  DTFormatMoneyColumn (col, val) {
    return '$' + (val[col] / 100).toFixed(2)
  },
  FormatStringFrequencyColumn (frequency, freqVal) {
    if (frequency === 0) {
      return 'With Plan'
    } else if (frequency === 1) {
      return 'As Needed'
    } else if (frequency === 2) {
      return 'At Start'
    } else {
      return freqVal + ' Months'
    }
  },
  DTFormatYesNo (col, val) {
    return val[col] ? 'Yes' : 'No'
  }

}
